import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const FloatingContact = () => {
    const { settings, loading } = useSettings();

    const phone = loading ? '' : (settings.phone || '');
    const whatsapp = settings.whatsapp || '905523067171';
    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg md:hidden">
            <div className="flex items-center justify-around py-3 px-4">
                <a
                    href={`tel:${phone}`}
                    className="flex items-center justify-center space-x-2 bg-blue-700 text-white px-6 py-3 rounded-full hover:bg-blue-800 transition-all shadow-lg flex-1 mx-2"
                    aria-label={`Telefon: ${phone}`}
                >
                    <Phone size={20} aria-hidden="true" />
                    <span className="font-semibold">Ara</span>
                </a>
                <a
                    href={`https://api.whatsapp.com/send/?phone=${whatsapp}&text&type=phone_number&app_absent=0`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 bg-green-700 text-white px-6 py-3 rounded-full hover:bg-green-800 transition-all shadow-lg flex-1 mx-2"
                    aria-label="WhatsApp ile iletişime geç"
                >
                    <MessageCircle size={20} aria-hidden="true" />
                    <span className="font-semibold">WhatsApp</span>
                </a>
            </div>
        </div>
    );
};

export default FloatingContact;
